module.exports = __webpack_public_path__ + "img/4.0c0214c0.png";